<template>
	<div class="backstage-home">
		<HomeHeader v-if="isShowHomeHeader"/>
		<PageHeader v-else/>
		<router-view></router-view>
		<!-- <Footer/> -->
	</div>
</template>

<script>
	import PageHeader from './components/PageHeader.vue'
	import HomeHeader from './components/HomeHeader.vue'
	// import Footer from './components/Footer.vue'
	export default {
		components:{
			PageHeader,
			HomeHeader,
			// Footer
		},
		data(){
			return {
				isShowHomeHeader:true
			}
		},
		watch:{
			$route:{
				handler(val){
					if (val.path === '/backstage/index' || val.path === '/backstage') {
						this.isShowHomeHeader = true
					}else{
						this.isShowHomeHeader = false
					}
				},
				immediate:true
			}
			
		}
		
	}
</script>

<style scoped>

</style>